import { debounce } from '../helpers/helpers';

/**
 * Set src attributes of specified elements only when they appear in the viewport
 */
const lazyLoad = () => {
  // eslint-disable-next-line no-undef
  const $ = jQuery;

  const $lazy = $('.js-lazy');

  const loadElementsInViewport = () => {
    const scrollY = window.pageYOffset;

    $lazy.toArray().forEach((elem) => {
      const elemPosition = elem.getBoundingClientRect().top + scrollY - window.innerHeight;
      if (scrollY > elemPosition + 100 && !elem.dataset.loaded) {
        elem.src = elem.dataset.src;
        elem.dataset.loaded = true;
      }
    });
  };

  if ($lazy.length) {
    loadElementsInViewport();
    $(window).on('scroll', debounce(100, loadElementsInViewport));
  }
};

export default lazyLoad;
